// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import LedgerApiClientV2 from '../utils/LedgerApiClientV2';

const ERROR_MESSAGE =
  'Ledger API client is not initialized. ' +
  'This usually means you have not connected to the Wallet Gateway yet, ' +
  'or the component is not wrapped with LedgerApiClientProvider. ' +
  'Please ensure you are connected to the Wallet Gateway before performing ledger operations.';

export const LedgerApiContextV2 = React.createContext<LedgerApiClientV2 | undefined>(undefined);

export const useLedgerApiClient: () => LedgerApiClientV2 = () => {
  const client = useContext(LedgerApiContextV2);
  if (!client) {
    throw new Error(ERROR_MESSAGE);
  }
  return client;
};
